// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";

function PlaceOrderFooter(Props) {
  var handleNextButton = Props.handleNextButton;
  var handleBackButtonOpt = Props.handleBackButton;
  var showBackButtonOpt = Props.showBackButton;
  var showFareOpt = Props.showFare;
  var isDisabledOpt = Props.isDisabled;
  var fareOpt = Props.fare;
  var handleBackButton = handleBackButtonOpt !== undefined ? handleBackButtonOpt : (function (param) {
        
      });
  var showBackButton = showBackButtonOpt !== undefined ? showBackButtonOpt : false;
  var showFare = showFareOpt !== undefined ? showFareOpt : false;
  var isDisabled = isDisabledOpt !== undefined ? isDisabledOpt : false;
  var fare = fareOpt !== undefined ? Caml_option.valFromOption(fareOpt) : Currency.toCurrency(0.0);
  var match = CountryContext.useContext(undefined);
  var match$1 = PlaceOrderContext.useContext(undefined);
  var dispatch = match$1.dispatch;
  var state = match$1.state;
  var symbol = CountryConfig.getSymbol(match.country);
  var snackbarMessage = state.snackbarMessage;
  var match$2 = ToastSnackbarHook$Catalyst.useSnackbar(3000, undefined, undefined);
  var openSnackbar = match$2[1];
  React.useEffect((function () {
          if (snackbarMessage !== undefined) {
            Curry._1(openSnackbar, snackbarMessage);
            Curry._1(dispatch, /* ClearSnackbar */0);
          }
          
        }), [snackbarMessage]);
  return React.createElement("div", {
              className: "footer"
            }, match$2[0], React.createElement("p", {
                  className: "fare-detail"
                }, showFare ? React.createElement(React.Fragment, undefined, "Total", React.createElement("span", undefined, Currency.toCurrencyString(fare, symbol))) : null), React.createElement("div", {
                  className: "btn-container"
                }, showBackButton ? React.createElement(Button$Catalyst.make, {
                        text: "Back",
                        cb: (function (param) {
                            return Curry._1(handleBackButton, undefined);
                          }),
                        className: "btn-secondary"
                      }) : null, React.createElement(Button$Catalyst.make, {
                      text: state.currentStep === /* ConfirmOrderStep */2 ? "Place Order" : "Next",
                      cb: (function (param) {
                          return Curry._1(handleNextButton, undefined);
                        }),
                      className: "btn-primary",
                      disabled: isDisabled
                    })));
}

var make = PlaceOrderFooter;

export {
  make ,
  
}
/* react Not a pure module */
